import type {StreakLeg} from './types.ts';
import {selectionLabel} from '../exchange/market-format.ts';
export function displaySelection(l:Pick<StreakLeg,'market'|'selection'|'home_team'|'away_team'>):string {
 const m=l.market.replace(/^(first|second)_half_/,'');
 const n=(s:string)=>s.replace('_','.');
 const total=m.match(/^(?:asian_)?total_(goals|corners|cards)_(over|under)_(\d+(?:_\d+)?)$/);
 if(total)return `${total[2]==='over'?'Over':'Under'} ${n(total[3]!)} ${total[1]}`;
 const team=m.match(/^team_goals_(home|away)_(over|under)_(\d+(?:_\d+)?)$/);
 if(team)return `${team[1]==='home'?l.home_team:l.away_team}: ${team[2]==='over'?'over':'under'} ${n(team[3]!)} goals`;
 const dc=m.match(/^double_chance_(home_or_draw|away_or_draw|home_or_away)$/);
 if(dc)return dc[1]==='home_or_draw'?`${l.home_team} or draw`:dc[1]==='away_or_draw'?`${l.away_team} or draw`:'Either team to win';
 const ah=m.match(/^asian_handicap_(home|away)_(plus|minus)_(\d+(?:_\d+)?)$/);
 if(ah)return `${ah[1]==='home'?l.home_team:l.away_team} ${ah[2]==='plus'?'+':'−'}${n(ah[3]!)}`;
 return selectionLabel(l.market,l.selection,l);
}
export function displayMarket(code:string):string {
 const prefix=code.startsWith('first_half_')?'First half · ':code.startsWith('second_half_')?'Second half · ':'';
 const m=code.replace(/^(first|second)_half_/,'');
 return prefix+(/team_goals/.test(m)?'Team goals':/total_goals/.test(m)?'Total goals':/double_chance/.test(m)?'Double chance':/asian_handicap/.test(m)?'Asian handicap':/corners/.test(m)?'Corners':/cards/.test(m)?'Cards':/btts/.test(m)?'Both teams to score':/draw_no_bet/.test(m)?'Draw no bet':/clean_sheet/.test(m)?'Clean sheet':'Match result');
}
